import React from "react";
import { AddToolTip } from "../../../components";
import { useHistory } from "react-router-dom";
import {
  FLOW_TYPES,
  MANAGE_FEE_ROUTES,
  getAdvancedPathWithParam,
} from "../../../utils";

const SpecificationInformationCard = ({ listdata }) => {
  const history = useHistory();
  console.log("listData", listdata);
  return (
    <div
      className="w-100 cursor-pointer cardDetails"
      onClick={() => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_FEE_ROUTES.CREATE_SPECIFICATION_INFORMATION,
            pathParam: [FLOW_TYPES.EDIT, listdata?.id],
          })
        );
      }}
    >
      <div className="ml-4 mt-3 nameDetails">
        {listdata?.name?.length < 10 ? (
          <div className="ft-14 fw-600">{listdata?.name}</div>
        ) : (
          <>
            {listdata?.name == null ? (
              <>{"-"}</>
            ) : (
              <>
                <AddToolTip className="ft-14 fw-600" name={listdata?.name}>
                  {listdata?.name?.slice(0, 10)}...
                </AddToolTip>
              </>
            )}
          </>
        )}
      </div>

      <div className="ml-4 mt-3 nameDetails">
        {listdata?.description?.length < 20 ? (
          <div className="ft-14 fw-500">{listdata?.description}</div>
        ) : (
          <>
            {listdata?.description == null ? (
              <>{"-"}</>
            ) : (
              <>
                <AddToolTip
                  className="ft-14 fw-500"
                  name={listdata?.description}
                >
                  {listdata?.description?.slice(0, 20)}...
                </AddToolTip>
              </>
            )}
          </>
        )}
      </div>

      <div className="mt-3 feesType">
        {listdata.feeType == 1 ? (
          <div className="ft-14 fw-500">{"Balance Based"}</div>
        ) : (
          <div className="ft-14 fw-500">{"Investment Based"}</div>
        )}
        <div className="ft-14 fw-500">{listdata.FeeType}</div>
      </div>

      <div className="mt-3">
        {/* <div className="ft-10 fw-500 grey">Allocation Type</div> */}
        {listdata.allocationType == 1 ? (
          <div className="ft-14 fw-500">{"Fixed Amount"}</div>
        ) : listdata.allocationType == 2 ? (
          <div className="ft-14 fw-500">{"Percentage/Basis Points"}</div>
        ) : (
          <div className="ft-14 fw-500">{"Tiered"}</div>
        )}
      </div>
    </div>
  );
};

export default SpecificationInformationCard;
